import { RichText } from "@/components/RichText";
import type { Customers as Data } from "@/lib/types";

export default function Customers({ data }: { data: Data }) {
  return (
    <section className="customers" id="customers">
      <div className="customers-inner">
        <div className="section-header">
          <span className="section-eyebrow">{data.eyebrow}</span>
          <RichText as="h2" className="section-title" html={data.title} />
          <p className="section-sub">{data.sub}</p>
        </div>
        <div className="customer-grid">
          {data.cards.map((card) => (
            <div className="customer-card" key={card.name}>
              <div className="customer-name">{card.name}</div>
              <span className="customer-sub">{card.sub}</span>
              <div className="customer-stats-row">
                {card.stats.map((s) => (
                  <div key={s.small}>
                    <div className="customer-stat-big">{s.big}</div>
                    <div className="customer-stat-small">{s.small}</div>
                  </div>
                ))}
              </div>
              <p className="customer-quote">{card.quote}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
